import { useEffect, useState, useRef } from 'react';
import SvgMovie from '../../../components/SvgMovie';
import config from '../../common/config';
import useSvgPlay from '../../../hooks/useSvgPlay';

import './styles/Digest1.less';

const Digest1 = ({ seq, play = false, onDataLoaded }: any) => {
  const [delayPlay, setDelayPlay] = useState(false);
  const [playQ, setPlayQ] = useState(false);
  const logoQRef: any = useRef();
  const slide: any = config.slides[seq];

  useEffect(() => {
    if (play) {
      setTimeout(() => {
        setDelayPlay(true);
      }, 10);
    } else {
      setDelayPlay(false);
      setPlayQ(false);
    }
  }, [play]);

  useSvgPlay(slide.svgs[0], playQ, logoQRef);

  return (
    <div className={`digest-wrapper digest-wrapper-${seq}`}>
      <SvgMovie
        src={slide.svgMovie}
        play={delayPlay}
        className="full-screen-svg"
        onEnterFrame={(e: any) => {
          if (e.currentTime > 190) {
            setPlayQ(true);
          }
        }}
        onDataLoaded={onDataLoaded}
      />
      <div className="digest">
        <div ref={logoQRef} className="logo-q"></div>

        <div className="text-block">
          <div className={`titles ${playQ ? 'ani-fade-in' : ''}`}>
            <div className="title title-primary">设计品质</div>
            <div className="title title-secondary">美学依据</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Digest1;
